import { IApiClientOptions } from 'core';
import { AssureBaseApiClient, HTTP_METHOD } from './assure-base-api-client';
import { ICreateExternalRepositorySettings, IUpdateExternalRepositorySettings, IParentAccountInfo } from '../dto/account-configuration.dto';
import { ICreateWelcomePackOptions } from 'dto/welcome-pack.dto';

export class AccountConfigurationApiClient extends AssureBaseApiClient {

    constructor(options: IApiClientOptions) {
        super('accountConfiguration', options);
    }

    protected getRootPath(): string {
        return 'account-configuration';
    }

    public async getExternalVisibility(apiAccountId: number): Promise<{ visible: boolean }> {
        return this.send<{ visible: boolean }>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(apiAccountId, 'external-repo/visibility'));
    }
   public async getExternalRepoSettings(apiAccountId: number, accountUuid: string, params?: IParentAccountInfo): Promise<{ repoSettings: unknown }> {    
      return this.send<{ repoSettings: unknown }>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/external-repo`, params));
    }

    public async createExternalRepoSettings(apiAccountId: number, accountUuid: string, params?: ICreateExternalRepositorySettings): Promise<{ repoSettings: unknown }> {
        return this.send<{ repoSettings: unknown }>(HTTP_METHOD.POST, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/external-repo`, params));
    }

    public async updateExternalRepoSettings(apiAccountId: number, accountUuid: string, params?: IUpdateExternalRepositorySettings): Promise<{ result: boolean }> {
        return this.send<{ result: boolean }>(HTTP_METHOD.PUT, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/external-repo`, params));
    }

    public async deleteExternalRepoSettings(apiAccountId: number, accountUuid: string): Promise<{ result: boolean }> {
        return this.send<{ result: boolean }>(HTTP_METHOD.DELETE, this.getRequestOptionsWithAccountId(apiAccountId, accountUuid));
    }

    async createWelcomePack(apiAccountId: number, accountUuid: string, wpConfiguration: ICreateWelcomePackOptions): Promise<{ welcomePack: unknown }> {
        return this.send<{ welcomePack: unknown }>(HTTP_METHOD.POST, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/welcome-pack`, wpConfiguration));
    }

    async getWelcomePacks(apiAccountId: number, accountUuid?: string): Promise<{ welcomePacks: unknown[] }> {
        return this.send<{ welcomePacks: unknown[] }>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/welcome-pack/list`));
    }

    async inactivateWelcomePack(apiAccountId: number, accountUuid: string, welcomePackId: number, force?: boolean): Promise<{ updated: boolean }> {
        return this.send<{ updated: boolean }>(HTTP_METHOD.PUT, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/welcome-pack/${welcomePackId}?force=${force || false}`));
    }

    async getDeviceExecutionsByStep(apiAccountId: number, accountUuid: string, welcomePackId: number, stepName: string): Promise<{ deviceExecutions: unknown[] }> {
        return this.send<{ deviceExecutions: unknown[] }>(HTTP_METHOD.GET, this.getRequestOptionsWithAccountId(apiAccountId, `${accountUuid}/welcome-pack/${welcomePackId}/${stepName}/executions`));
    }
}

